export default __webpack_public_path__ + "static/media/showhide.10d5e16f.svg";